export default __webpack_public_path__ + "static/media/io.3e6c973f.svg";